// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Google = Caml_module.init_mod([
      "proto/third_party/google_type/gen/google_type_date.ml",
      83,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "$$Date"
              ]]
          },
          "Type"
        ]]
    });

const Type = Caml_module.init_mod([
      "proto/third_party/google_type/gen/google_type_date.ml",
      137,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "$$Date"
        ]]
    });

const $$Date = Caml_module.init_mod([
      "proto/third_party/google_type/gen/google_type_date.ml",
      173,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".google.type.Date";
}

function make(yearOpt, monthOpt, dayOpt, param) {
  const year = yearOpt !== undefined ? yearOpt : 0;
  const month = monthOpt !== undefined ? monthOpt : 0;
  const day = dayOpt !== undefined ? dayOpt : 0;
  return {
          year: year,
          month: month,
          day: day
        };
}

const merge_year = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "year",
            "year"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_month = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "month",
            "month"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_day = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "day",
            "day"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

function merge(t1, t2) {
  return {
          year: Curry._2(merge_year, t1.year, t2.year),
          month: Curry._2(merge_month, t1.month, t2.month),
          day: Curry._2(merge_day, t1.day, t2.day)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "year",
                    "year"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "month",
                        "month"
                      ],
                      Ocaml_protoc_plugin__Spec.int32_int,
                      0
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "day",
                            "day"
                          ],
                          Ocaml_protoc_plugin__Spec.int32_int,
                          0
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.year, param.month, param.day);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(year, month, day) {
  return {
          year: year,
          month: month,
          day: day
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".google.type.Date", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.year, param.month, param.day);
  };
}

function constructor$1(year, month, day) {
  return {
          year: year,
          month: month,
          day: day
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".google.type.Date", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, $$Date, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "$$Date"
        ]]
    }, Type, {
      $$Date: $$Date
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "$$Date"
              ]]
          },
          "Type"
        ]]
    }, Google, {
      Type: Type
    });

export {
  Imported$pmodules ,
  Google ,
}
/* Google Not a pure module */
